import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PopularArticles from '../containers/PopularArticles';
import PromptContainer from '../containers/PromptContainer';
import TopicList from '../containers/TopicList';
import ChatBot from '../../contactUs/components/ChatBot';
import AuthPromptModal from '../containers/AuthPromptModal';

import { loadModalContainer } from '../../contactUs/actions/action-login-modal';
import { chatBotClickedAction } from '../../contactUs/actions/action-chat-bot';
import { chatBotLoaded } from '../actions/action-chat-bot';
import Page from '../../lib/page';

const isHelpCenterHomePageChatEligible = Page.isHelpCenterHomePageChatEligible();
const chatBotPostServiceEnabled = Page.isChatBotPostServiceEnabled();
const isLoggedIn = Page.isLoggedIn();

/**
 * Changing HomePage from stateless component to get the chatBot Eligibility API response
 */

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.chatBotClicked = this.chatBotClicked.bind(this);
  }

  chatBotClicked() {
    // Let's open up the login modal.
    if (isLoggedIn) {
      return null;
    }
    this.props.chatBotClickedAction();
    sessionStorage.setItem('articlePagechatBotClicked', 'true');
    return this.props.loadModalContainer('chatBot');
  }

  chatBotLoad() {
    this.props.chatBotLoaded();
  }

  renderChatBotHome() {
    const { chatBotDisplay, chatBotTriggerMode } = this.props; // postChatbot API eligible/un-eligible condition to show/hide chatBot
    // chatBotPostServiceEnabled is Remote Config check for postChatBot Eligibility API
    const display = chatBotPostServiceEnabled ? chatBotDisplay : isHelpCenterHomePageChatEligible;
    if (!display) {
      return null;
      // if chatbottrigger mode is open open the chat window irespective of whether chat/chatbot click happened
    } else if (chatBotTriggerMode === 'OPEN') {
      return this.chatBotLoad();
    }
    return <ChatBot link="smarthelp-chat-bot-home" id="chatBotHome" topicRefId="GENPOOL|homePage" chatBotClicked={this.chatBotClicked} display />;
  }

  render() {
    return (<div className="home-content-container">
      <PopularArticles />
      <div className="topic-list__grid">
        <TopicList />
      </div>
      <div className="prompt-container__grid">
        <PromptContainer />
      </div>
      {this.renderChatBotHome()}
      <AuthPromptModal />
    </div>);
  }
}

HomePage.propTypes = {
  chatBotDisplay: PropTypes.string.isRequired,
  chatBotTriggerMode: PropTypes.string.isRequired,
  loadModalContainer: PropTypes.func.isRequired,
  chatBotClickedAction: PropTypes.func,
  chatBotLoaded: PropTypes.func.isRequired,
};

HomePage.defaultProps = {
  chatBotClickedAction: () => {},
};

// Get the postChatBotEligibility redux data and Pass it as Props.
function mapStateToProps(state) {
  return {
    chatBotDisplay: state.postChatBotEligibility.chatBotDisplay,
    chatBotTriggerMode: state.postChatBotEligibility.chatBotTriggerMode,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ loadModalContainer, chatBotClickedAction, chatBotLoaded }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
